module.exports = {
  Rating: {
    PluginName: "Valoración",
    ShowStars: "Mostrar estrellas en vez de números",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    pos: "Posición",
    radius: "Radio",
    source: "Fuente",
    Number: "Nº de Niveles",
    tryAgain: "Inténtalo de nuevo",
    checkAnswer: "Comprueba la respuesta",
  },
};
